import React, { useState } from "react";
import CheckIcon from "images/design-system-svgs/check.svg";
import { ShortlistType, type ShortlistProps } from "./types";
import HeapHelpers from "helpers/heap-helpers";

const Shortlist: React.FC<ShortlistProps> = ({
  addStyleToShortlist,
  onClickFavoriteShortlist,
  productId,
  removeStyleFromShortlist,
  shortlist,
  styleNames,
}) => {
  const [productInShortlist, setProductInShortlist] = useState(!!productId && styleNames.includes(productId));
  const [error, setError] = useState(false);

  const toggleOnFailureCallback = () => {
    setProductInShortlist(prev => !prev);
    setError(true);
  };

  const toggleProductInShortlist = () => {
    if (shortlist.shortlistId === ShortlistType.ALL_HEARTS) {
      onClickFavoriteShortlist();
      return;
    }

    if (!productId) {
      return;
    }

    const newProductInShortlist = !productInShortlist;
    setProductInShortlist(newProductInShortlist);
    setError(false);

    if (newProductInShortlist) {
      HeapHelpers.fireHeapEvent("sf-add-item-to-shortlist", {
        shortlistName: shortlist.name,
        productId: productId,
      });
      addStyleToShortlist(shortlist.shortlistId, productId, null, toggleOnFailureCallback);
    } else {
      HeapHelpers.fireHeapEvent("sf-remove-item-from-shortlist", {
        shortlistName: shortlist.name,
        productId: productId,
      });
      removeStyleFromShortlist(shortlist.shortlistId, productId, null, toggleOnFailureCallback);
    }
  };

  const onClickCheck = (e: React.MouseEvent) => {
    e.preventDefault();
    toggleProductInShortlist();
  };

  const isChecked = productInShortlist || shortlist?.shortlistId === ShortlistType.HEARTS;

  return (
    <button
      type="button"
      className="shortlist flex w-full items-center justify-between text-left"
      onClick={onClickCheck}
      data-style-name={productId}
      data-shortlist-name={shortlist.name}
      data-test-id={error ? "error" : "no-error"}>
      <span className="mr-4">{shortlist.name}</span>
      <div className="flex-shrink-0">
        {isChecked ? (
          <div
            data-test-id="checked-icon"
            className="w-6 h-6 bg-white border border-wine flex items-center justify-center rounded-sm">
            <CheckIcon className="w-4 h-4 text-wine" />
          </div>
        ) : (
          <div data-test-id="unchecked-icon" className="w-6 h-6 border border-darkerGray rounded-sm" />
        )}
      </div>
    </button>
  );
};

export default Shortlist;
